import { NgOptimizedImage } from '@angular/common';
import { Component, ElementRef, ChangeDetectorRef, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { FormBuilder, ReactiveFormsModule, FormGroup } from '@angular/forms';
import { buildFieldValidators, getMaxLengthFromRules } from '../../utilities/form-validators.utility';
import { ToastComponent } from '../toast/toast.component';
import { RouterModule } from '@angular/router';
import { InputMaskDirective } from '../../directives/inputMask.directive';
import { ModalService } from '../../services/modal.service';
import { CongratulationPopupComponent } from '../congratulation-popup/congratulation-popup.component';
import { CommonApiService } from '../../services/commonapi.service';

@Component({
    selector: 'app-footer',
    imports: [NgOptimizedImage, ReactiveFormsModule, ToastComponent, RouterModule, InputMaskDirective,
        CongratulationPopupComponent],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
})
export class FooterComponent implements OnInit {
    currentYear = new Date().getFullYear();
    touchWithUs!: FormGroup;
    message: any;
    showToastSuccess: boolean = false;
    showToastFailure: boolean = false;
    private formId = 'subscribe-form';
    stayInTouchTitle = 'Stay in touch';
    fields: any[] = [];

    constructor(private readonly formBuilder: FormBuilder, private readonly el: ElementRef, private readonly commonApiService: CommonApiService,
        private readonly modalService: ModalService, private readonly cdr: ChangeDetectorRef) { }

    ngOnInit(): void {
        this.buildForm();
        this.commonApiService.getPageData('footer').subscribe({
            next: (res: any) => {
                const sec = res?.data?.footer_section_form_sec;
                if (sec?.title) this.stayInTouchTitle = sec.title;
                if (sec?.form?.form_id) this.formId = sec.form.form_id;
                if (sec?.form?.fields?.length) this.fields = sec.form.fields;
                this.buildForm();
                this.cdr.markForCheck();
            },
            error: () => { }
        });
    }

    private buildForm(): void {
        const controls: any = {};
        if (this.fields.length) {
            this.fields.forEach((field: any) => {
                const { validators } = buildFieldValidators(field);
                controls[field.name] = ['', validators];
            });
        } else {
            controls['email'] = [''];
        }
        this.touchWithUs = this.formBuilder.group(controls);
    }

    private getValidators(field: any) {
        return buildFieldValidators(field).validators;
    }

    getMaxLength(field: any): number {
        return getMaxLengthFromRules(field?.validation?.rules || [], field?.type);
    }

    getEmailField(): any {
        return this.fields.find((f: any) => f.type === 'email') || { name: 'email', label: 'Email' };
    }

    onSubmit() {
        this.touchWithUs.markAllAsTouched();
        if (this.touchWithUs.invalid) {
            for (const key of Object.keys(this.touchWithUs.controls)) {
                if (this.touchWithUs.controls[key].invalid) {
                    const invalidControl = this.el.nativeElement.querySelector('[formcontrolname="' + key + '"]');
                    invalidControl?.focus();
                    break;
                }
            }
            return;
        } else {
            this.submitData();
        }
    }

    submitData() {
        const fields: { [key: string]: string } = {};
        Object.keys(this.touchWithUs.value).forEach(key => {
            fields[key] = this.touchWithUs.value[key] ?? '';
        });
        const payload = { form_id: this.formId, fields };
        this.commonApiService.submitForm(payload).subscribe({
            next: (response: any) => {
                if (response?.status === 200 || response?.success) {
                    this.message = response?.message || 'The submission was successful.';
                    this.showToastSuccess = true;
                    this.showToastFailure = false;
                    this.modalService.showModal('congrts');
                    this.touchWithUs.reset();
                } else {
                    this.message = response?.message || 'OOPS!, Something went Wrong!';
                    this.showToastSuccess = false;
                    this.showToastFailure = true;
                }
            },
            error: (err: any) => {
                this.message = err?.error?.message || 'OOPS!, Something went Wrong!';
                this.showToastSuccess = false;
                this.showToastFailure = true;
            }
        });
    }
    assetsCDNUrl = environment.assetsCDNUrl;
    linkData = [
        {
            name: 'About us',
            title: 'About us',
            url: 'about-us',

        },
        {
            name: 'Solutions',
            title: 'Solutions',
            url: 'solutions'
        },
        {
            name: 'Insights',
            title: 'Insights',
            url: 'insights'
        },
        {
            name: 'Media Corner',
            title: 'Media Corner',
            url: 'media-corner'
        },
        {
            name: 'Blog',
            title: 'Blog',
            url: 'blog',
            blank: true
        },
        {
            name: 'Contact Us',
            title: 'Contact Us',
            url: 'contact-us'
        },
        {
            name: 'Privacy Policy',
            title: 'Privacy Policy',
            url: 'assets/pdf/privacy-policy.pdf',
            blank: true
        },
        {
            name: 'Disclaimer,<br/>Terms & Conditions',
            title: 'Disclaimer, Terms & Conditions',
            url: '/assets/pdf/Disclaimer-Terms-Conditions-for-website_19022026.pdf',
            blank: true
        },
        {
            name: 'Customer Onboarding Terms & Conditions',
            title: 'Customer Onboarding Terms & Conditions',
            url: '/assets/pdf/Customer-Onboarding-Terms-and-Conditions-for-website_19022026.pdf',
            blank: true
        },
        {
            name: 'Sitemap',
            title: 'Sitemap',
            url: 'sitemap'
        },
    ]
    socialMedia = [
        {
            title: 'Facebook',
            imgUrl: '/assets/images/icons/fb.svg',
            url: 'https://www.facebook.com/profile.php?id=61570845327379'
        },
        {
            title: 'x',
            imgUrl: '/assets/images/icons/x.svg',
            url: 'https://x.com/ShriramWealth01'
        },
        {
            title: 'linkedin',
            imgUrl: '/assets/images/icons/linked.svg',
            url: 'https://www.linkedin.com/company/shriram-wealth/about/'
        },
        {
            title: 'instagram',
            imgUrl: '/assets/images/icons/instagram.svg',
            url: 'https://www.instagram.com/shriram.wealth/'
        },
        {
            title: 'youtube',
            imgUrl: '/assets/images/youtube.svg',
            url: 'https://www.youtube.com/@ShriramWealth-q1d'
        }
    ]
}
